var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('SiteMasthead',{attrs:{"mini":"true","title":"Rental Emergency Contacts"}}),_c('ContentRow',[_c('ContentContainer',[_c('div',{staticClass:"about-office",domProps:{"innerHTML":_vm._s(_vm.office.EmergencyContacts)}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }